import React, { useContext, useEffect, useState, useRef } from 'react';
import styles from './Tickets.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { IpContext, TokenContext, TYPES, ABIContext } from '../../components/Context';
import { Web3Context } from '../../web3/Web3Context';
import IconPolygonSmall from '../../assets/icons/icon-polygon.png';
import IconBinance from '../../assets/icons/BSC_network.png';
import IconBinanceWhite from '../../assets/icons/icon_binance_white.png';
import IconOpenSeaWhite from '../../assets/icons/icon_opensea_white.png';
import IconBridge from '../../assets/icons/icon_bridge.png';
import IconTransfer from '../../assets/icons/icon_transfer.png';
import GoldTicketImg from '../../assets/imgs/gold_ticket.png';
import SilverTicketImg from '../../assets/imgs/silver_ticket.png';
import BronzeTicketImg from '../../assets/imgs/bronze_ticket.png';
import { Button, Image, Overlay, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import IconMoreOptions from '../../assets/icons/icon-dots.png';
import { createContract } from '../../services/contractService';
import { SkinAndTicketTransfer } from '../SkinAndTicketTransfer/SkinAndTicketTransfer';
import { allTokenTypes } from '../Skins/utils';
import { PolygonNetworkInfo, BinanceNetworkInfo } from '../../services/networkServices';
import Loader from '../../assets/imgs/loader.gif';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import facebookIcon from '../../assets/icons/facebook1.png';
import telegramIcon from '../../assets/icons/telegramIcon.svg';
import twitterIcon from '../../assets/icons/twitterIcon.svg';
import sharelinkIcon from '../../assets/icons/sharelinkIcon.svg';
import { copyToClipboard } from '../../helpers';

const withdrawlURL = 'https://www.binance.com/en/support/faq/a2fb25696162460f9379c0ba43c5c622';
const binanceTicketsURL = 'https://www.binance.com/en/nft/profile/animoca-brands-ad3bcf389e3eb2213724659b99b94cd0?category=created';
const openseaURL = 'https://opensea.io/';
const OPENSEA_URL = process.env.REACT_APP_OPENSEA_URL;
const CDH_BACKEND_API = process.env.REACT_APP_BACKEND_API;

const Tickets = (props) => {
    const { walletConnected } = props;
    const { selectedAccount, networkId, connect, switchNetwork, web3, provider } = useContext(Web3Context);
    const [state, dispatch] = useContext(TokenContext);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [tokenTypeForTransfer, setTokenTypeForTransfer] = useState('');
    const [maxTokenCount, setMaxTokenCount] = useState(0);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const [t] = useTranslation();
    const history = useHistory();
    const [bridgingStatus, setBridgingStatus] = useState('');
    const [binanceTicketsFetched, setBinanceTicketsFetched] = useState(false);
    const [switching, setSwitching] = useState(false);
    const [polygonTicketsFetched, setPolygonTicketsFetched] = useState(false);
    
    const [popOverMenu, setPopOverMenu] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState('');
    const [socialShareLinks, setSocialShareLinks] = useState([]);
    const {isInChina} = useContext(IpContext);
    const tooltipTarget = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const getSocialLinks = (towerInventoryAddress='0x432de13822e0b891748b632cd94f85ba4cbbcdfa', tokenId='1') => {
        return [
          {
            icon: facebookIcon,
            name: 'Facebook',
            link: 'https://www.facebook.com/sharer/sharer.php?u=' +  OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: telegramIcon,
            name: 'Telegram',
            link: 'https://telegram.me/share/url?url=' + OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: twitterIcon,
            name: 'Twitter',
            link: 'https://twitter.com/intent/tweet?url=' + OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: sharelinkIcon,
            name: 'Copy Link',
            copyLink: OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
        ];
    }

    const WALLET_BRIDGING_STATUS_URL = `${process.env.REACT_APP_BACKEND_API}/bridging/${selectedAccount}`;

    const {
        skinAndTicket: { 
            ticketContract,
            polygonTowerInventoryContract,
            nftReceiverContract,
        },
        polygonProvider,
        binanceProvider,
        polygonDeploymentContext,
        binanceDeploymentContext
    } = abiConfig;

    const initializeTicketContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            // use default provider when connected to BSC network
            contract = await createContract(binanceDeploymentContext, 'Ticket', provider);
        } else {
            contract = await createContract(binanceDeploymentContext, 'Ticket', binanceProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_TICKET_CONTRACT,
                payload: {
                    ticketAddress: contract.options.address,
                    ticketContract: contract, 
                }
            });
        }
    }

    const initializePolygonTicketContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_POLYGON_CHAIN_ID)) {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', provider);
        } else {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', polygonProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_POLYGON_TOWER_INVENTORY_CONTRACT,
                payload: {
                    polygonTowerInventoryAddress: contract.options.address,
                    polygonTowerInventoryContract: contract,
                }
            });
        }
    }

    const initializeNFTReceiverContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            contract = await createContract(binanceDeploymentContext, 'NFTReceiver', provider);
        } else {
            contract = await createContract(binanceDeploymentContext, 'NFTReceiver', binanceProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_NFT_RECEIVER_CONTRACT,
                payload: {
                    nftReceiverAddress: contract.options.address,
                    nftReceiverContract: contract,
                }
            })
        }
    }

    const fetchBinanceTickets = async () => {
        try {
            // initialize empty arrays that will later store token ids and respective balances
            let ticketBalance = {
                gold: {
                    count: 0,
                    tokens: [],
                },
                silver: {
                    count: 0,
                    tokens: [],
                },
                bronze: {
                    count: 0,
                    tokens: [],
                },
            }
            const totalTicketCount = await ticketContract.methods.balanceOf(selectedAccount).call();
            let ticketIds = []
            // get token ids from balance and push to ticketBalance
            if(totalTicketCount > 0) {
                for(let i=0; i < totalTicketCount; i++) {
                    let ticketTokenId = await ticketContract.methods.tokenOfOwnerByIndex(selectedAccount, i).call();
                    ticketIds.push(ticketTokenId)
                }
            }

            let ticketBackendAPI = CDH_BACKEND_API + "/ticketmetadata";
            const data = { 
                "tokenIds": ticketIds
            }

            let rawTokenMetaData = await axios.post(ticketBackendAPI, data).catch((err) => err.response);

            if(rawTokenMetaData && rawTokenMetaData?.status === 200) {
                ticketBalance = rawTokenMetaData.data;
            }


            dispatch({
                type: TYPES.SET_TICKET_COUNT_BSC,
                payload: ticketBalance,
            });

            setBinanceTicketsFetched(true);
        } catch(e) {
            console.log(`Error is: ${e}`);
        }
    }

    const fetchPolygonTickets = async () => {
        try {
            // initialize empty arrays that will later store token ids and respective balances
            let polygonTicketBalance = {
                gold: {
                    count: 0,
                    tokenId: 1, // erc-1155 contract for TowerInventory in polygon has tokenId as 1 for gold
                },
                silver: {
                    count: 0,
                    tokenId: 2, // erc-1155 contract for TowerInventory in polygon has tokenId as 2 for silver
                },
                bronze: {
                    count: 0,
                    tokenId: 3, // erc-1155 contract for TowerInventory in polygon has tokenId as 3 for bronze
                },
            }

            for(let i=1; i <= 3; i++) {
                const ticketCode = i;
                const ticketTokenType = allTokenTypes[ticketCode].toString();
                const ticketBalance = await polygonTowerInventoryContract.methods.balanceOf(selectedAccount, ticketCode).call();
                polygonTicketBalance[ticketTokenType]['count'] = ticketBalance;
            }

            dispatch({
                type: TYPES.SET_TICKET_COUNT_MATIC,
                payload: polygonTicketBalance,
            });

            setPolygonTicketsFetched(true);
        } catch(e) {
            console.log(`Error is: ${e}`);
        }
    }

    const bscTicketData = {
        totalTicketCount: parseInt(state.ticketBalance.bsc.gold.count) + parseInt(state.ticketBalance.bsc.silver.count) + parseInt(state.ticketBalance.bsc.bronze.count),
        gold: {
            img: GoldTicketImg,
            name: 'Gold',
            quantity: state.ticketBalance.bsc.gold.count
        },
        silver: {
            img: SilverTicketImg,
            name: 'Silver',
            quantity: state.ticketBalance.bsc.silver.count
        },
        bronze: {
            img: BronzeTicketImg,
            name: 'Bronze',
            quantity: state.ticketBalance.bsc.bronze.count
        }
    }

    const polygonTicketData = {
        totalTicketCount: parseInt(state.ticketBalance.polygon.gold.count) + parseInt(state.ticketBalance.polygon.silver.count) + parseInt(state.ticketBalance.polygon.bronze.count),
        gold: {
            img: GoldTicketImg,
            name: 'Gold',
            quantity: state.ticketBalance.polygon.gold.count
        },
        silver: {
            img: SilverTicketImg,
            name: 'Silver',
            quantity: state.ticketBalance.polygon.silver.count
        },
        bronze: {
            img: BronzeTicketImg,
            name: 'Bronze',
            quantity: state.ticketBalance.polygon.bronze.count
        }
    }

    const renderBSCNoTickets = (
        <div className={styles.bsc_no_tickets}>
            <div className={styles.bsc_no_tickets_text}>
                {t('TICKETS_EMPTY_TITLE')}
            </div>
            <div className={styles.bsc_no_tickets_description}>
                {t('BUY_FROM_BINANCE')}
            </div>
            <div>
                <Button className={styles.bsc_binance_btn}>
                    <div className={styles.bsc_btn_icon}>
                        <Image width="16" src={IconBinanceWhite} />
                    </div>
                    <a href={binanceTicketsURL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.bsc_btn_text}>
                            {'Go To Binance'}
                        </div>
                    </a>
                </Button>
            </div>
            <div className={styles.withdrawl_description}>
                {t('TICKET_WITHDRAWL_DESCRIPTION')}
            </div>
            <a href={withdrawlURL} target="_blank" rel="noopener noreferrer">
                <div className={styles.bsc_how_to_link}>
                    {t('HOW_TO_WITHDRAW')}
                </div>
            </a>
        </div>
    );

    const renderPolygonNoTickets = (
        <div className={styles.polygon_no_tickets}>
            <div className={styles.polygon_no_tickets_text}>
                {t('TICKETS_EMPTY_TITLE')}
            </div>
            <div className={styles.polygon_no_tickets_description}>
                {'You are able to purchase in OpenSea.'}
            </div>
            <div>
                <Button className={styles.polygon_opensea_btn}>
                    <div className={styles.polygon_btn_icon}>
                        <Image width="16" src={IconOpenSeaWhite} />
                    </div>
                    <a href={openseaURL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.polygon_btn_text}>
                            {t('GO_OPENSEA_BTN')}
                        </div>
                    </a>
                </Button>
            </div>
        </div>
    );

    const renderAdditionalPopUp = (ticketImageText) => {
        setPopOverMenu(true);
        setSelectedTicket(ticketImageText);
    }

    const renderBSCSingleTicket = (ticketImageSource, ticketImageText, ticketCount) => {
        return (
            <div className={styles.bsc_singletkt_tickets}>
                <div className={styles.bsc_singletkt_header}>
                    <div className={styles.bsc_singletkt_bsc_logo}>
                        <img src={IconBinance} alt="bnb" />
                    </div>
                    
                    {/* Hiding the more options button on the Ticket items */}
                    {/* <div className={styles.bsc_singletkt_more_options} onClick={ () => renderAdditionalPopUp(ticketImageText) }>
                        <Image width="18" height="4" src={IconMoreOptions} alt="more-options" />
                    </div> */}

                </div>
                <div className={styles.bsc_singletkt_image_with_count}>
                    <div className={styles.bsc_singletkt_image}>
                        <Image width="122" height="84" src={ticketImageSource}></Image>
                    </div>
                    <div className={styles.bsc_singletkt_amt}>
                        {`x${ticketCount}`}
                    </div>
                </div>
                <div className={styles.bsc_singletkt_text}>
                    {ticketImageText}
                </div>
                
                <div className={styles.bsc_singletkt_divider}>
                </div>
                
                <div>
                    <Button disabled={ticketCount < 1 || bridgingStatus === 'minting' || switching} className={`${styles.bsc_singletkt_bridge_btn} ${switching ? styles.bsc_singletkt_bridge_btn_disabled : ''}`} onClick={() => bridgeWrapper(ticketImageText)}>
                        <div className={styles.bsc_singletkt_bridge_icon}>
                            <Image width="16" src={IconBridge} />
                        </div>
                        <div className={styles.bsc_singletkt_bridge_text}>
                            {`${(networkId != parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) ? 'Switch' : t('BRIDGE_POLYGON_BTN')}`}
                        </div>
                    </Button>
                </div>
            </div>
        );
    }

    const bridgeWrapper = (ticketName) => {
        if(networkId != parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            switchNetwork(BinanceNetworkInfo)
            setSwitching(true);
        } else {
            initiateTicketBridging(ticketName);
        }
    }

    const initiateTicketBridging = (ticketName) => {
        const bridgingTicketType = ticketName.toLowerCase();
        
        dispatch({
            type: TYPES.SET_BRIDGING_TICKET_TYPE_BSC,
            payload: bridgingTicketType,
        });

        history.push('/bridge/tickets');
    }

    const renderPolygonSingleTicket = (ticketImageSource, ticketImageText, ticketCount) => {
        return (
            <div className={styles.polygon_singletkt_tickets}>
                <div className={styles.polygon_singletkt_header}>
                    <div className={styles.polygon_singletkt_polygon_logo}>
                        <img src={IconPolygonSmall} alt="polygon" />
                    </div>
                    <div className={styles.polygon_singletkt_more_options} onClick={ () => renderAdditionalPopUp(ticketImageText)}>
                        <Image width="18" height="4" src={IconMoreOptions} alt="more-options" />
                    </div>

                    {/* Rendering of overlay */}
                    {(selectedTicket === ticketImageText) && 
                    <div className={`${styles.bsc_singletkt_options_popup} ${popOverMenu && styles.displayBlock}`}>
                        <span className={styles.closeBtn} onClick={() => setPopOverMenu(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                        <h3 className={styles.title}>{ticketImageText}</h3>
                        <ul className={styles.shareLinks}>
                            {socialShareLinks.map((item, idx) => {
                                if (!item.disabled && !item.copyLink) {
                                return (
                                    <li key={idx}>
                                    <a href={item.link?.toLowerCase()} target="_blank" rel="noreferrer noopener"><img src={item.icon} alt='' />{item.name}</a>
                                    </li>
                                );
                                } else if (!item.disabled) {
                                return (
                                    <li key={idx}>
                                    <span className={styles.copyToClipboard} onClick={() => copyToClipboard(item.copyLink)}><img src={item.icon} alt='' />{item.name}</span>
                                        <Overlay target={tooltipTarget.current} ref={tooltipTarget} show={showTooltip} placement="top">
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                {'Copied'}
                                            </Tooltip>
                                        )}
                                        </Overlay>
                                    </li>
                                );
                                }
                            })}
                        </ul>

                        <button className={`${styles.transferBtn} ${(ticketCount == 0) ? styles.transferBtnDisabled : ''}`} onClick={() => initiateTransfer(selectedTicket)}>
                            <img src={IconTransfer} alt="transfer" />
                            {'Transfer'}
                        </button>
                    </div>}
                </div>
                <div className={styles.polygon_singletkt_image_with_count}>
                    <div className={styles.polygon_singletkt_image}>
                        <Image width="122" height="84" src={ticketImageSource}></Image>
                    </div>
                    <div className={styles.polygon_singletkt_amt}>
                        {`x${ticketCount}`}
                    </div>
                </div>
                <div className={styles.polygon_singletkt_text}>
                    {ticketImageText}
                </div>
        
                <div className={styles.polygon_singletkt_divider}>
                </div>
                <div>
                    {/* TODO: Redemption action */}
                    <Button disabled className={styles.polygon_singletkt_transfer_btn} onClick={() => initiateRedemption(ticketImageText)}>
                        <div className={styles.polygon_singletkt_transfer_icon}>
                            <Image width="24" src={IconTransfer} />
                        </div>
                        <div className={styles.polygon_singletkt_transfer_text}>
                            {t('REDEEM')}
                        </div>
                    </Button>
                </div>
            </div>
        );
    }

    const renderBridgingInProgress = (
        <div className={styles.bridging_in_progress}>
            <span>{'Bridging is currently in progress. You cannot bridge other tokens while bridging is in progress'}</span>
        </div>
    );

    const renderBridgingFailed = (
        <div className={styles.bridging_failed}>
            <span>{'Mint transaction failed. Our system will re-attempt to mint corresponding token to your wallet address. Please check again later!'}</span>
        </div>
    );

    const renderTicketsLoading = (
        <div className={styles.tickets_loading}>
            <div>
                <img className={styles.tickets_loading_icon} src={Loader} alt="loading" />
            </div>
            <div className={styles.tickets_loading_text}>
                {`We're loading your inventory...`}
            </div>
        </div>
    );

    const renderBSCTickets = (bscTicketData) => {
        // const allTicketsCount = bscTicketData['totalTicketCount'];
        const allTicketsName = Object.keys(bscTicketData).filter((keyName) => keyName !== 'totalTicketCount');
        const allTickets = allTicketsName.map((ticket) => {
            return bscTicketData[ticket]
        });

        return (
            <>
                {/* <div className={styles.bsc_tickets_count}>
                    {`Total: ${allTicketsCount}`}
                </div> */}
                {allTickets.map((ticket) => {
                    return (
                        <div key={ticket['name']} className={styles.bsc_tickets}>
                            { renderBSCSingleTicket(ticket['img'], ticket['name'], ticket['quantity']) }
                        </div>
                    )
                })}
            </>
        );
    }

    const initiateTransfer = async (polygonTicketText) => {
        let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
        if (!switchNetworkResponse) {
            return;
        }

        const maxCount = polygonTicketData[polygonTicketText.toLowerCase()]['quantity']
        setShowTransferModal(true);
        setTokenTypeForTransfer(polygonTicketText);
        setMaxTokenCount(maxCount);
    }

    const initiateRedemption = (ticketImageText) => {
        console.log("DO TICKET REDEMPTION HERE!!");
    }

    const renderPolygonTickets = (polygonTicketData) => {
        const allTicketsName = Object.keys(polygonTicketData).filter((keyName) => keyName !== 'totalTicketCount');
        const allTickets = allTicketsName.map((ticket) => {
            return polygonTicketData[ticket]
        });

        return (
            allTickets.map((ticket) => {
                return (
                    <div key={ticket['name']} className={styles.polygon_tickets}>
                        { renderPolygonSingleTicket(ticket['img'], ticket['name'], ticket['quantity']) }
                    </div>
                )
            })
        );
    }

    // useEffect(() => {
    //     if(selectedAccount) {
    //         const fetchWalletBridgingStatus = setInterval(async () => {
    //             try {
    //                 const rawResult = await axios.get(WALLET_BRIDGING_STATUS_URL);
    //                 if(rawResult.status === 200) {
    //                     const res = rawResult.data;
    //                     setBridgingStatus(res.status)
    //                 }
    //             } catch(e) {
    //                 console.log(`Error: ${e}`);
    //             }
    //         }, 60000);
    //     }
    // }, [selectedAccount])

    useEffect(() => {
        const contractInitializer = async() => {
            await initializeTicketContract();
            await initializePolygonTicketContract();
            await initializeNFTReceiverContract();
            setSwitching(false);
        }

        if(provider && binanceDeploymentContext && binanceProvider && polygonProvider && polygonDeploymentContext) {
            contractInitializer();
        }
    }, [provider, networkId, binanceDeploymentContext, binanceProvider, polygonDeploymentContext, polygonProvider]);

    useEffect(() => {
        if(selectedAccount && polygonTowerInventoryContract) {
            fetchPolygonTickets();
        }
    }, [polygonTowerInventoryContract, selectedAccount]);

    useEffect(() => {
        if(selectedAccount && ticketContract) {
            fetchBinanceTickets();
        }
    }, [ticketContract, selectedAccount]);

    // Function definition for setting social links
    useEffect(() => {
        if(polygonDeploymentContext && selectedTicket && polygonTicketsFetched) {
            const polygonTowerContractAddr = polygonDeploymentContext.contracts.TowerInventory.address;
            const selectedTokenId = ((selectedTicket == 'Gold') && '1') || ((selectedTicket == 'Silver') && '2') || ((selectedTicket == 'Bronze') && '3')
            let socialLinksResult = getSocialLinks(polygonTowerContractAddr, selectedTokenId);
            setSocialShareLinks([...socialLinksResult]);
        }
        
    }, [polygonTicketsFetched, selectedTicket])

    return (
        <>
        {walletConnected ?
            <div className={styles.tickets_items_section}>
                <div className={styles.ticket_main_text}>
                    <div className={styles.ticket_bridging_text}>{t('TICKETS_MAIN_TITLE')}</div>
                    <div className={styles.total_tickets}>{`Total: ${bscTicketData.totalTicketCount + polygonTicketData.totalTicketCount}`}</div>
                </div>
                <div className={styles.ticket_network_groups}>
                    <div className={`${styles.bsc_network_group} ${styles.bsc_network_background}`}>
                        
                        <div className={styles.bsc_network_title}>
                            <div className={styles.bsc_network_icon}>
                                <Image src={IconBinance} />
                            </div>
                            <div className={styles.bsc_network_description}>
                                <div className={styles.bsc_network_text}>
                                    {'Network'}
                                </div>
                                <div className={styles.bsc_network_name}>
                                    {'BNB'}
                                </div>
                            </div>
                        </div>
                        <div className={styles.bsc_network_hr_line}></div>
                        
                        <div>
                            {bridgingStatus === 'minting' ?
                                renderBridgingInProgress :
                                bridgingStatus === 'failed' ?
                                    renderBridgingFailed : ''
                            }
                        </div>

                        <div className={styles.bsc_network_content}>
                            {!binanceTicketsFetched ?
                                renderTicketsLoading : (
                                binanceTicketsFetched && (bscTicketData.totalTicketCount > 0) ?
                                    renderBSCTickets(bscTicketData) :
                                    renderBSCNoTickets
                                )
                            }
                        </div>
                    </div>

                    <div className={`${styles.polygon_network_group} ${styles.polygon_network_background}`}>
                        <div className={styles.polygon_network_title}>
                            <div className={`${styles.polygon_network_icon} ${styles.polygon_network_icon_background}`}>
                                <Image width="34" height="34" src={IconPolygonSmall} />
                            </div>
                            <div className={styles.polygon_network_description}>
                                <div className={styles.polygon_network_text}>
                                    {'Network'}
                                </div>
                                <div className={styles.polygon_network_name}>
                                    {'Polygon'}
                                </div>
                            </div>
                        </div>
                        <div className={styles.polygon_network_hr_line}></div>
                        <div className={styles.polygon_network_content}>
                            {!polygonTicketsFetched ?
                                renderTicketsLoading : (
                                    polygonTicketsFetched && (polygonTicketData.totalTicketCount > 0) ?
                                        renderPolygonTickets(polygonTicketData) :
                                        renderPolygonNoTickets
                                )
                            }
                        </div>
                    </div>
                </div>
            </div> :
            <div className={styles.no_tickets_section}>
                <div className={styles.main_text}>{t('CONNECT_WALLET_ACCESS_INVENTORY')}</div>
                <div className={styles.secondary_text}>{t('NO_ITEMS_WITHOUT_CONNECT')}</div>
                <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={connect}>{t('CONNECT')}</Button>
            </div>}

            { 
                showTransferModal === true 
                    ? <SkinAndTicketTransfer
                        web3={web3}
                        showTransferModal={showTransferModal}
                        setShowTransferModal={setShowTransferModal}
                        switchNetwork={switchNetwork}
                        PolygonNetworkInfo= {PolygonNetworkInfo}
                        maxTokenCount={maxTokenCount}
                        tokenTypeForTransfer={tokenTypeForTransfer} />
                    : <></>
            }
            
        </>
    )
}

export { Tickets }
